<template>
  <v-input
    :rules="rules"
    :value="value"
    :hint="hint || undefined"
    :persistent-hint="!!hint"
    :hide-details="!hint"
    :disabled="disabled"
  >
    <ol class="week-display">
      <li
        v-for="(day, i) in $options.week_days_char"
        class="week-day-circ"
        :class="{ 'week-day-selected': has_day(i) }"
        :style="style"
        :key="`week_day_${i}`"
        @click="emit_day_click(i)"
      >{{ day }}</li>
    </ol>
  </v-input>
</template>
<script>
export default {
  name: "WeekDayDisplay",
  props: {
    selectedDays: {
      type: Number,
      required: false,
      default: 0,
    },
    value: {
      type: Number,
      required: false,
      default: -1,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    fontSize: {
      type: String,
      required: false,
      default: "10px",
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false,
    }
  },
  week_days_char: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  computed: {
    style() {
      return {
        "font-size": this.fontSize,
      }
    }
  },
  methods: {
    has_day(i) {
      return (this.selectedDays && (this.selectedDays >> i) & 1) ||
             (this.value >= 0   && (this.value        >> i) & 1);
    },
    emit_day_click(i) {
      this.$emit("day-click", i);
      this.emit_input(i);
    },
    emit_input(i) {
      const new_val = this.value ^ (1 << i);
      if (this.value >= 0 && new_val !== 0)
        this.$emit("input", new_val);
    },
  },
};
</script>
<style scoped>

.week-display {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0 0.6em;
}

.week-day-circ {
  display: block;
  flex: 0 1 auto;
  list-style-type: none;
  background-color: #00000038;
  border: solid 1px #00000040;
  color: #ffffff9c;
  border-radius: 50%;
  width: 1.8em;
  height: 1.8em;
  text-align: center;
  line-height: 1.6em;
  font-weight: bold;
}

.week-day-selected {
  border: none;
  background-color: #ffffff8c;
  color: #747474;
  line-height: 1.85em;
}
</style>
